(function () {
  'use strict';

  document.querySelectorAll('[data-bunk-pdp]').forEach(function (root) {
    var sliders = Array.prototype.slice.call(root.querySelectorAll('[data-size-slider]'));
    if (!sliders.length) return;

    function numberFor(slider) {
      return root.querySelector('[data-field="' + slider.dataset.sizeSlider + '"]');
    }

    function paint(slider) {
      var min = Number(slider.min);
      var max = Number(slider.max);
      var value = Number(slider.value);
      var progress = max === min ? 0 : ((value - min) / (max - min)) * 100;
      slider.style.setProperty('--bmp-range-progress', progress + '%');
    }

    function syncSlider(slider) {
      var number = numberFor(slider);
      if (!number || number.value === '') return;
      var value = Math.max(Number(slider.min), Math.min(Number(slider.max), Math.round(Number(number.value))));
      if (!Number.isFinite(value)) return;
      if (slider.value !== String(value)) slider.value = String(value);
      paint(slider);
    }

    function syncAll() {
      sliders.forEach(syncSlider);
    }

    sliders.forEach(function (slider) {
      slider.addEventListener('input', function () {
        var number = numberFor(slider);
        if (!number) return;
        number.value = slider.value;
        paint(slider);
        number.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-field="width"], [data-field="length"]')) return;
      var confirmation = root.querySelector('[data-measurement-confirm]');
      if (confirmation) confirmation.checked = false;
      var slider = root.querySelector('[data-size-slider="' + event.target.dataset.field + '"]');
      if (slider) syncSlider(slider);
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-field="width"], [data-field="length"]')) syncAll();
    });

    root.addEventListener('click', function () {
      window.requestAnimationFrame(syncAll);
    });

    var syncTimer = window.setInterval(syncAll, 500);
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains(root)) window.clearInterval(syncTimer);
    });

    syncAll();
  });
})();
